import Head from 'next/head';
import ToolsFooter from '@/components/ToolsFooter';
import { ToolsFooterCode } from '@/components/codeHighlights/FooterCode';

const Page = () => {
  return (
    <>
      <Head>
        <title>Tools-Footer</title>
      </Head>
      <h1>Tools-Footer</h1>
      <p className="lead">
        Verwenden Sie diesen Footer für interne Applikationen/Services.
        FHNW-Webdienste nutzen zwingend den Webdienst-Footer.
      </p>

      <ToolsFooter />
      <div className="mt-5">
        <h2>HTML-Code Example</h2>
        <ToolsFooterCode />
      </div>
    </>
  );
};

export default Page;
